import { render } from "./ListMarcas.vue?vue&type=template&id=21575af6"
import script from "./ListMarcas.vue?vue&type=script&lang=js"
export * from "./ListMarcas.vue?vue&type=script&lang=js"

import "./ListMarcas.vue?vue&type=style&index=0&id=21575af6&lang=css"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__